import { render, staticRenderFns } from "./WithdrawalPolicyModal.vue?vue&type=template&id=1f06fe5a&scoped=true"
import script from "./WithdrawalPolicyModal.vue?vue&type=script&lang=js"
export * from "./WithdrawalPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalPolicyModal.vue?vue&type=style&index=0&id=1f06fe5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06fe5a",
  null
  
)

export default component.exports